import { Box, styled, Theme, Typography } from '@mui/material'
import { SxProps } from '@mui/system'
import React from 'react'
import { colors } from '../../../themes/colors'

const Wrapper = styled(Box)``
const Label = styled(Typography)``
const _LargeText = styled(Typography)`
  font-weight: 300;
  font-size: 40px;
  line-height: 120%;
  color: 'inherit';
`

const LargeText = styled(_LargeText)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    fontSize: 32,
  },
}))

interface Props {
  label: string
  unit: string
  color?: string
  sx?: SxProps<Theme>
  testId?: string
}

const _colors = {
  primary: colors.primary500,
  secondary: colors.secondary700,
  undefined: undefined,
}
export const UnitText = ({ label, unit, color = 'primary', testId, ...props }: Props) => {
  const txColor = _colors[color as keyof typeof _colors] ?? color
  return (
    <Wrapper sx={props.sx}>
      <Label variant='body2' color={txColor} data-testid={testId} data-label='label'>
        {label}
      </Label>
      <LargeText color={txColor} data-testid={testId} data-label='amount'>
        {unit}
      </LargeText>
    </Wrapper>
  )
}
